(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["add-to-cart-button"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[id^="notify-form-"]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var email = form.querySelector('input[name="email"]').value;
        var productId = form.dataset.productId;
        var productTitle = form.dataset.productTitle;

        // Guarda localmente como backup
        var existing = JSON.parse(localStorage.getItem('bis_requests') || '[]');
        existing.push({
          email: email,
          product_id: productId,
          product_title: productTitle,
          date: new Date().toISOString()
        });
        localStorage.setItem('bis_requests', JSON.stringify(existing));

        // Muestra confirmación
        form.querySelector('.product-unavailable__input-group').style.display = 'none';
        form.querySelector('.product-unavailable__confirm').style.display = 'block';
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-availability-button"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[id^="notify-form-"]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var email = form.querySelector('input[name="email"]').value;
        var productId = form.dataset.productId;
        var productTitle = form.dataset.productTitle;

        // Guarda en localStorage como backup inmediato
        var key = 'notify_' + productId;
        var existing = JSON.parse(localStorage.getItem('bis_requests') || '[]');
        existing.push({
          email: email,
          product_id: productId,
          product_title: productTitle,
          date: new Date().toISOString()
        });
        localStorage.setItem('bis_requests', JSON.stringify(existing));

        // Muestra confirmación
        form.querySelector('.product-unavailable__input-group').style.display = 'none';
        form.querySelector('.product-unavailable__confirm').style.display = 'block';

        // Envía a Customer Pixel / o simplemente muestra confirmación
        // Si tienes Klaviyo o Shopify Email puedes añadir el endpoint aquí
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
